module.exports = __webpack_public_path__ + "static/media/phone-trade-sell.b73d904b.png";